export default {
    topics: [
        {
            title: ' CheckJavaScript ',
            href: 'sm-publishing-CheckJavaScript.html',
            attributes: { 'data-id': 'sm-publishing-CheckJavaScript' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-CheckJavaScript-d66e2013',
            topics: [],
        },
        {
            title: ' CheckXSLT ',
            href: 'sm-publishing-CheckXSLT.html',
            attributes: { 'data-id': 'sm-publishing-CheckXSLT' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-CheckXSLT-d66e2021',
            topics: [],
        },
        {
            title: ' GenerateForDelivery ',
            href: 'sm-publishing-GenerateForDelivery.html',
            attributes: { 'data-id': 'sm-publishing-GenerateForDelivery' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-GenerateForDelivery-d66e2029',
            topics: [],
        },
        {
            title: ' GenerateFromId ',
            href: 'sm-publishing-GenerateFromId.html',
            attributes: { 'data-id': 'sm-publishing-GenerateFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-GenerateFromId-d66e2037',
            topics: [],
        },
        {
            title: ' GenerateFromSel ',
            href: 'sm-publishing-GenerateFromSel.html',
            attributes: { 'data-id': 'sm-publishing-GenerateFromSel' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-GenerateFromSel-d66e2045',
            topics: [],
        },
        {
            title: ' LoadContent ',
            href: 'sm-publishing-LoadContent.html',
            attributes: { 'data-id': 'sm-publishing-LoadContent' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-LoadContent-d66e2053',
            topics: [],
        },
        {
            title: ' Transform ',
            href: 'sm-publishing-Transform.html',
            attributes: { 'data-id': 'sm-publishing-Transform' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-Transform-d66e2061',
            topics: [],
        },
        {
            title: ' TransformFromId ',
            href: 'sm-publishing-TransformFromId.html',
            attributes: { 'data-id': 'sm-publishing-TransformFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-TransformFromId-d66e2069',
            topics: [],
        },
        {
            title: ' TransformJavaScript ',
            href: 'sm-publishing-TransformJavaScript.html',
            attributes: { 'data-id': 'sm-publishing-TransformJavaScript' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-TransformJavaScript-d66e2077',
            topics: [],
        },
        {
            title: ' TransformJavaScriptDOM ',
            href: 'sm-publishing-TransformJavaScriptDOM.html',
            attributes: { 'data-id': 'sm-publishing-TransformJavaScriptDOM' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-TransformJavaScriptDOM-d66e2085',
            topics: [],
        },
        {
            title: ' TransformXSLT ',
            href: 'sm-publishing-TransformXSLT.html',
            attributes: { 'data-id': 'sm-publishing-TransformXSLT' },
            menu: { hasChildren: false },
            tocID: 'sm-publishing-TransformXSLT-d66e2094',
            topics: [],
        },
    ],
};

